import { render } from "./OrderDetails.vue?vue&type=template&id=6042cc79&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=6042cc79&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6042cc79"

export default script